<template>
  <div style="position: sticky !important; top: 0; width: 100%; z-index: 10000; ">
    <div :style="`--accent-color: ${university.color};`" class="w-100 nav d-none d-md-block">
      <div class="container py-0">
        <div style=" border-bottom: 1px solid #eaeeef;" class="nav-container">
          <svg class="logo" style="margin-right: 20px" viewBox="0 0 80 70" width="48" height="48">
            <g :fill="university.color" transform="translate(0,0)">
              <g fill-rule="" class="tp-name" transform="translate(5.8380584716796875,0)">
                <g transform="scale(1)">
                  <g>
                    <path
                      d="M15.79-46.61L24.89-1.69Q25.09-0.78 24.57-0.03 24.05 0.72 23.21 0.91L23.21 0.91 22.82 0.91Q22.1 0.91 21.48 0.42 20.87-0.07 20.73-0.78L20.73-0.78 18.98-9.23 8.45-9.23 6.76-0.78Q6.63-0.07 6.01 0.42 5.4 0.91 4.62 0.91L4.62 0.91 4.23 0.91Q3.38 0.72 2.89-0.03 2.41-0.78 2.6-1.69L2.6-1.69 11.63-46.61Q11.7-46.87 11.77-46.93L11.77-46.93 11.77-47 11.77-47.06Q11.89-47.39 12.09-47.52L12.09-47.52 12.09-47.65 12.16-47.65 12.16-47.71 12.22-47.71 12.22-47.77 12.29-47.77 12.29-47.84 12.35-47.84Q12.48-47.97 12.61-48.04 12.74-48.1 12.94-48.16L12.94-48.16 12.94-48.23 13-48.23Q13.13-48.3 13.29-48.3 13.46-48.3 13.59-48.36L13.59-48.36 13.65-48.36 13.78-48.36 13.85-48.36Q13.97-48.3 14.14-48.3 14.3-48.3 14.43-48.23L14.43-48.23 14.5-48.23 14.5-48.16Q14.76-48.1 14.88-48.04 15.02-47.97 15.15-47.84L15.15-47.84 15.21-47.84 15.21-47.77 15.28-47.77 15.28-47.71 15.34-47.71 15.34-47.65Q15.34-47.65 15.41-47.52L15.41-47.52Q15.47-47.39 15.57-47.29 15.67-47.19 15.73-47.06L15.73-47.06 15.73-47 15.73-46.93Q15.79-46.87 15.79-46.61L15.79-46.61ZM9.29-13.46L18.14-13.46 13.65-35.43 9.29-13.46ZM35.43 0.33L35.43 0.33Q34.45 0.33 33.8-0.36 33.15-1.04 33.15-1.95L33.15-1.95 33.15-45.76Q33.15-46.67 33.8-47.35 34.45-48.04 35.43-48.04L35.43-48.04Q36.34-48.04 37.02-47.35 37.7-46.67 37.7-45.76L37.7-45.76 37.7-1.95Q37.7-1.04 37.02-0.36 36.34 0.33 35.43 0.33ZM58.95 0.58L58.95 0.58Q54.41 0.58 51.29-2.02L51.29-2.02Q50.05-3.06 48.85-5.17 47.65-7.28 47.65-10.92L47.65-10.92Q47.65-11.89 48.33-12.54 49.01-13.2 49.98-13.2L49.98-13.2Q50.9-13.2 51.55-12.54 52.2-11.89 52.2-10.92L52.2-10.92Q52.2-8.78 52.81-7.41 53.43-6.04 54.41-5.3 55.38-4.55 56.58-4.26 57.79-3.97 58.95-3.97L58.95-3.97Q59.61-3.97 60.81-4.13 62.01-4.29 63.18-5 64.35-5.72 65.23-7.08 66.11-8.45 66.11-10.92L66.11-10.92Q66.11-13.33 65.42-15.15 64.74-16.96 63.54-18.39 62.34-19.82 60.78-21.03 59.22-22.23 57.46-23.46L57.46-23.46Q55.9-24.57 54.31-25.8 52.72-27.04 51.42-28.54L51.42-28.54Q48.36-32.11 48.3-36.79L48.3-36.79Q48.3-37.05 48.33-37.83 48.36-38.61 48.55-39.65L48.55-39.65Q49.14-42.97 51.16-45.18L51.16-45.18Q54.08-48.23 59.02-48.23L59.02-48.23Q64.03-48.23 66.75-45.18L66.75-45.18Q67.73-44.07 68.31-42.64 68.9-41.21 69.03-39.52L69.03-39.52Q69.16-38.35 69.13-37.54 69.09-36.73 69.03-36.59L69.03-36.59Q68.84-35.75 68.58-35.1L68.58-35.1Q68.25-34.58 67.8-34.19 67.34-33.8 66.43-33.93L66.43-33.93Q65.52-34.06 65.13-34.61 64.74-35.16 64.61-35.75L64.61-35.75Q64.42-36.47 64.55-37.25L64.55-37.25Q64.68-38.16 64.55-39L64.55-39Q64.42-39.72 64.16-40.59 63.9-41.47 63.31-42.19L63.31-42.19Q62.01-43.75 59.02-43.75L59.02-43.75Q56.03-43.75 54.54-42.05L54.54-42.05Q53.82-41.34 53.46-40.43 53.11-39.52 52.98-38.8L52.98-38.8Q52.78-37.9 52.84-37.05L52.84-37.05 52.84-36.86Q52.84-35.23 53.37-33.93 53.89-32.63 54.83-31.53 55.77-30.42 57.1-29.35 58.44-28.28 60.13-27.04L60.13-27.04Q62.01-25.8 63.8-24.41 65.59-23.01 67.15-21.13L67.15-21.13Q70.66-16.84 70.66-10.92L70.66-10.92Q70.66-7.93 69.65-5.75 68.64-3.58 66.98-2.18 65.33-0.78 63.21-0.1 61.1 0.58 58.95 0.58Z"
                      transform="translate(-2.546119451522827, 48.36000061035156)"
                    />
                  </g>
                </g>
              </g>
              <g fill-rule="" class="tp-slogan" :fill="university.color" transform="translate(0,55.27000045776367)">
                <g mask="url(#253c8e33-315e-44fc-97ca-7978f4831f5c)">
                  <g>
                    <rect stroke-width="2" class="i-icon-bg" x="0" y="0" width="79.79000091552734" height="12.160000801086426" fill-opacity="1" />
                  </g>
                  <g transform="translate(5,2)">
                    <g transform="scale(1, 1)" fill="#fefefd">
                      <g transform="scale(1)">
                        <path
                          d="M1.08-7.87L1.08 0L2.08 0L2.08-3.12L3.49-3.12C3.92-3.12 4.32-3.17 4.67-3.27C5.03-3.37 5.34-3.52 5.59-3.72C5.85-3.92 6.05-4.17 6.19-4.48C6.33-4.78 6.40-5.14 6.40-5.56C6.40-5.99 6.33-6.35 6.19-6.65C6.05-6.94 5.85-7.18 5.60-7.36C5.35-7.54 5.04-7.67 4.68-7.75C4.32-7.83 3.92-7.87 3.49-7.87ZM3.37-3.94L2.08-3.94L2.08-7.07L3.37-7.07C4.05-7.07 4.56-6.96 4.90-6.74C5.23-6.52 5.40-6.12 5.40-5.56C5.40-5.00 5.23-4.59 4.90-4.33C4.57-4.07 4.06-3.94 3.37-3.94ZM11.68-4.14L11.68-7.07L13.00-7.07C13.62-7.07 14.09-6.96 14.42-6.76C14.75-6.55 14.91-6.18 14.91-5.66C14.91-5.15 14.75-4.77 14.42-4.52C14.09-4.27 13.62-4.14 13.00-4.14ZM15.01 0L16.14 0L14.14-3.43C14.68-3.57 15.11-3.82 15.43-4.19C15.75-4.56 15.91-5.05 15.91-5.66C15.91-6.07 15.84-6.42 15.70-6.70C15.57-6.98 15.38-7.20 15.13-7.38C14.89-7.56 14.60-7.68 14.26-7.76C13.92-7.83 13.55-7.87 13.15-7.87L10.69-7.87L10.69 0L11.68 0L11.68-3.32L13.11-3.32ZM23.26 0.14C23.76 0.14 24.21 0.05 24.62-0.14C25.03-0.34 25.39-0.61 25.69-0.97C25.99-1.32 26.22-1.75 26.39-2.26C26.55-2.77 26.63-3.34 26.63-3.97C26.63-4.60 26.55-5.16 26.39-5.66C26.22-6.16 25.99-6.58 25.69-6.93C25.39-7.28 25.03-7.55 24.62-7.73C24.21-7.92 23.76-8.02 23.26-8.02C22.76-8.02 22.31-7.92 21.90-7.74C21.49-7.56 21.13-7.29 20.84-6.94C20.54-6.59 20.31-6.17 20.15-5.67C19.98-5.17 19.90-4.60 19.90-3.97C19.90-3.34 19.98-2.77 20.15-2.26C20.31-1.75 20.54-1.32 20.84-0.97C21.13-0.61 21.49-0.34 21.90-0.14C22.31 0.05 22.76 0.14 23.26 0.14ZM23.26-0.73C22.91-0.73 22.59-0.81 22.31-0.96C22.02-1.11 21.78-1.33 21.57-1.61C21.37-1.90 21.21-2.24 21.10-2.63C20.99-3.03 20.93-3.48 20.93-3.97C20.93-4.46 20.99-4.90 21.10-5.29C21.21-5.68 21.37-6.02 21.57-6.29C21.78-6.56 22.02-6.77 22.31-6.92C22.59-7.07 22.91-7.14 23.26-7.14C23.61-7.14 23.93-7.07 24.21-6.92C24.50-6.77 24.74-6.56 24.95-6.29C25.15-6.02 25.31-5.68 25.42-5.29C25.53-4.90 25.59-4.46 25.59-3.97C25.59-3.48 25.53-3.03 25.42-2.63C25.31-2.24 25.15-1.90 24.95-1.61C24.74-1.33 24.50-1.11 24.21-0.96C23.93-0.81 23.61-0.73 23.26-0.73ZM30.55-1.62L29.83-1.12C30.30-0.28 31.02 0.14 32.01 0.14C32.39 0.14 32.72 0.08 33.00-0.05C33.27-0.18 33.50-0.35 33.67-0.58C33.84-0.80 33.97-1.06 34.05-1.36C34.14-1.66 34.18-1.98 34.18-2.32L34.18-7.87L33.17-7.87L33.17-2.41C33.17-1.81 33.07-1.38 32.86-1.12C32.65-0.86 32.33-0.73 31.91-0.73C31.63-0.73 31.38-0.80 31.15-0.94C30.93-1.08 30.73-1.31 30.55-1.62ZM39.00-7.87L39.00 0L43.65 0L43.65-0.85L39.99-0.85L39.99-3.71L42.98-3.71L42.98-4.56L39.99-4.56L39.99-7.03L43.53-7.03L43.53-7.87ZM47.56-3.94C47.56-3.30 47.65-2.72 47.82-2.21C47.99-1.71 48.23-1.28 48.54-0.93C48.85-0.58 49.21-0.32 49.63-0.13C50.05 0.05 50.51 0.14 51.01 0.14C51.51 0.14 51.96 0.04 52.35-0.16C52.74-0.36 53.09-0.64 53.41-1.00L52.84-1.61C52.59-1.33 52.32-1.11 52.03-0.96C51.75-0.81 51.41-0.73 51.03-0.73C50.65-0.73 50.32-0.81 50.02-0.96C49.72-1.11 49.46-1.33 49.25-1.61C49.05-1.89 48.88-2.23 48.77-2.62C48.65-3.02 48.59-3.46 48.59-3.96C48.59-4.45 48.65-4.89 48.77-5.28C48.89-5.67 49.06-6.01 49.28-6.28C49.49-6.56 49.75-6.77 50.06-6.92C50.36-7.07 50.70-7.14 51.08-7.14C51.41-7.14 51.71-7.07 51.96-6.94C52.21-6.81 52.44-6.63 52.65-6.41L53.21-7.04C52.98-7.30 52.69-7.53 52.33-7.72C51.97-7.92 51.55-8.02 51.07-8.02C50.56-8.02 50.10-7.92 49.67-7.73C49.24-7.55 48.87-7.28 48.56-6.92C48.25-6.57 48.00-6.14 47.83-5.64C47.65-5.14 47.56-4.57 47.56-3.94ZM58.98-7.03L58.98 0L59.99 0L59.99-7.03L62.37-7.03L62.37-7.87L56.61-7.87L56.61-7.03ZM66.03-1.72L65.43-1.02C65.78-0.66 66.19-0.38 66.66-0.17C67.13 0.04 67.64 0.14 68.19 0.14C68.61 0.14 68.98 0.09 69.31-0.03C69.64-0.15 69.92-0.31 70.15-0.51C70.38-0.71 70.56-0.95 70.68-1.22C70.81-1.50 70.87-1.79 70.87-2.10C70.87-2.39 70.83-2.64 70.74-2.86C70.66-3.08 70.55-3.27 70.40-3.44C70.26-3.60 70.09-3.75 69.89-3.87C69.69-3.99 69.47-4.10 69.25-4.20L68.13-4.68C67.97-4.74 67.82-4.81 67.67-4.89C67.51-4.97 67.37-5.05 67.25-5.15C67.12-5.25 67.02-5.37 66.94-5.50C66.86-5.63 66.83-5.80 66.83-5.99C66.83-6.35 66.96-6.63 67.23-6.83C67.50-7.04 67.85-7.14 68.29-7.14C68.66-7.14 68.99-7.07 69.28-6.94C69.57-6.81 69.84-6.63 70.08-6.40L70.62-7.04C70.34-7.33 70.00-7.57 69.60-7.75C69.20-7.93 68.76-8.02 68.29-8.02C67.93-8.02 67.60-7.96 67.30-7.86C67.00-7.76 66.74-7.61 66.52-7.42C66.30-7.23 66.13-7.01 66.00-6.76C65.88-6.50 65.82-6.22 65.82-5.93C65.82-5.64 65.87-5.39 65.96-5.17C66.06-4.95 66.18-4.76 66.33-4.60C66.49-4.44 66.66-4.30 66.85-4.19C67.04-4.08 67.23-3.98 67.41-3.90L68.54-3.41C68.73-3.32 68.90-3.24 69.06-3.16C69.22-3.08 69.36-2.99 69.47-2.89C69.59-2.79 69.68-2.67 69.75-2.53C69.82-2.39 69.85-2.22 69.85-2.02C69.85-1.63 69.71-1.32 69.42-1.09C69.13-0.85 68.73-0.73 68.21-0.73C67.80-0.73 67.40-0.82 67.02-1.00C66.64-1.18 66.31-1.42 66.03-1.72Z"
                          transform="translate(-1.08, 8.016)"
                        />
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </svg>
          <div :class="{ active: $route.name === 'home' }" @click="$router.push({ name: 'home' })" class="menu-item">
            <span> Главная</span>
          </div>
          <div :class="{ active: $route.fullPath.indexOf('projects') !== -1 }" @click="$router.push({ name: 'projects' })" class="menu-item">
            Проекты
          </div>
          <div :class="{ active: $route.fullPath.indexOf('cases') !== -1 }" @click="$router.push({ name: 'cases' })" class="menu-item">
            Кейсы
          </div>
          <div :class="{ active: $route.fullPath.indexOf('events') !== -1 }" @click="$router.push({ name: 'events' })" class="menu-item">
            Мероприятия
          </div>
          <div :class="{ active: $route.fullPath.indexOf('ai_links') !== -1 }" @click="$router.push({ name: 'ai_links' })" class="menu-item">
            Нейросети
          </div>
          <div
            v-if="$store.getters.isAuth && $store.state.user.currentUser.role === 'employee'"
            :class="{ active: $route.name === 'opd' }"
            @click="$router.push({ name: 'opd' })"
            class="menu-item"
          >
            ОПД
          </div>
          <div
            v-if="
              $store.state.user.currentUser.id > 0 && ($store.getters.checkPermission('can_manage_users') || $store.getters.checkPermission('can_manage_pools'))
            "
            :class="{ active: $route.fullPath.indexOf('admin') !== -1 }"
            @click="$router.push({ name: 'admin.groups' })"
            class="menu-item"
          >
            Админка
          </div>
          <div
            v-if="$store.state.user.currentUser.id > 0"
            :class="{ active: $route.fullPath.indexOf('hosting') !== -1 }"
            @click="$router.push({ name: 'hosting' })"
            class="menu-item"
          >
            Хостинг
          </div>
          <div style="width: 100%" />
          <div
            @click="$router.push({ name: 'profile', params: { id: $store.state.user.currentUser.id } })"
            v-if="$store.state.user.currentUser.id > 0"
            class="profile"
          >
            <v-avatar v-if="$store.state.user.currentUser.id > 0" size="36">
              <v-img :lazy-src="$store.state.user.currentUser.avatar_16" :src="$store.state.user.currentUser.avatar" />
            </v-avatar>
            <div style="flex-shrink: 0; margin-left: 0.5em;">
              {{ $store.state.user.currentUser.first_name }}
              {{ $store.state.user.currentUser.last_name }}
            </div>
            <v-icon class="ml-6" @click.stop="$store.dispatch('logout'), $router.push('/auth/login')">mdi-logout </v-icon>
          </div>
          <v-icon v-else @click="$router.push({ name: 'login' })">mdi-login</v-icon>
        </div>
      </div>
    </div>
    <div :style="`--accent-color: ${university.color};`" class="d-flex d-md-none nav__mobile">
      <div :class="{ active: $route.name === 'home' }" @click="$router.push({ name: 'home' })" class="icon__mobile">
        <svg height="24" viewBox="0 0 512 512" width="24" xmlns="http://www.w3.org/2000/svg">
          <path
            d="m498.195312 222.695312c-.011718-.011718-.023437-.023437-.035156-.035156l-208.855468-208.847656c-8.902344-8.90625-20.738282-13.8125-33.328126-13.8125-12.589843 0-24.425781 4.902344-33.332031 13.808594l-208.746093 208.742187c-.070313.070313-.140626.144531-.210938.214844-18.28125 18.386719-18.25 48.21875.089844 66.558594 8.378906 8.382812 19.445312 13.238281 31.277344 13.746093.480468.046876.964843.070313 1.453124.070313h8.324219v153.699219c0 30.414062 24.746094 55.160156 55.167969 55.160156h81.710938c8.28125 0 15-6.714844 15-15v-120.5c0-13.878906 11.289062-25.167969 25.167968-25.167969h48.195313c13.878906 0 25.167969 11.289063 25.167969 25.167969v120.5c0 8.285156 6.714843 15 15 15h81.710937c30.421875 0 55.167969-24.746094 55.167969-55.160156v-153.699219h7.71875c12.585937 0 24.421875-4.902344 33.332031-13.808594 18.359375-18.371093 18.367187-48.253906.023437-66.636719zm0 0"
          />
        </svg>
        <span>
          Главная
        </span>
      </div>
      <div :class="{ active: $route.fullPath.indexOf('projects') !== -1 }" @click="$router.push({ name: 'projects' })" class="icon__mobile">
        <svg height="24" viewBox="0 0 512 512" width="24" xmlns="http://www.w3.org/2000/svg">
          <path
            d="m74.742188 328.078125c-2.898438 5.78125-1.769532 12.769531 2.796874 17.339844l3.667969 3.667969c10.597657-12.558594 22.949219-26.1875 37.929688-41.164063 1.058593-1.058594 2.148437-1.570313 3.210937-2.546875l-23.597656-23.601562c-13.71875 24.8125-21.71875 41.765624-24.007812 46.304687zm0 0"
          />
          <path
            d="m203.988281 392.773438c-15.015625 15.015624-28.609375 27.390624-41.097656 37.996093l4.96875 4.96875c4.609375 4.609375 11.664063 5.71875 17.464844 2.734375 7.769531-4.003906 19.988281-9.753906 45.925781-24.199218l-24.710938-24.710938c-.976562 1.066406-1.488281 2.152344-2.550781 3.210938zm0 0"
          />
          <path
            d="m195.992188 315.9375c-10.839844-10.839844-41.324219-1.121094-55.644532 13.195312-47.90625 47.90625-69.542968 81.871094-79.257812 101.925782-2.785156 5.746094-1.625 12.625 2.890625 17.140625 4.523437 4.527343 11.414062 5.675781 17.164062 2.890625 19.605469-9.519532 53.15625-31.054688 101.632813-79.527344 15.746094-15.753906 23.515625-45.320312 13.226562-55.613281zm0 0"
          />
          <path
            d="m46.820312 199.710938-42.425781 42.425781c-4.796875 4.796875-5.78125 12.222656-2.382812 18.105469 3.316406 5.804687 10.261719 8.761718 16.871093 6.992187 22.929688-6.148437 43.105469-8.746094 56.691407-5.261719 19.328125-34.363281 40.097656-65.996094 62.09375-94.730468-12.722657-8.15625-54.765625-3.613282-90.847657 32.46875zm0 0"
          />
          <path
            d="m253.894531 510.390625c5.777344 2.921875 12.773438 1.792969 17.347657-2.785156l42.429687-42.425781c32.847656-32.855469 38.628906-75.246094 31.175781-88.6875-32.046875 24.152343-64.511718 44.546874-94.800781 61.621093 2.089844 11.800781.699219 23.25-4.242187 56.6875-.964844 6.472657 2.378906 12.734375 8.089843 15.589844zm0 0"
          />
          <path
            d="m297.800781 150.46875c-17.542969 17.546875-17.542969 46.089844 0 63.636719 17.546875 17.546875 46.09375 17.546875 63.640625 0s17.546875-46.089844 0-63.636719-46.09375-17.546875-63.640625 0zm0 0"
          />
          <path
            d="m511.117188 14.632812c-.539063-7.417968-6.445313-13.28125-13.839844-13.835937-36.839844-2.773437-73.535156 1.757813-109.503906 12.757813 2.707031 24.710937 15.488281 51.453124 37.308593 73.273437 22.082031 22.078125 49.550781 34.855469 74.703125 37.246094 9.6875-33.949219 14.28125-70.308594 11.332032-109.441407zm0 0"
          />
          <path
            d="m403.871094 108.042969c-24.960938-24.960938-40.203125-54.898438-45.09375-84.046875-90.074219 36.941406-176.300782 117.613281-244.4375 230.941406l33.851562 33.851562c23.128906-9.390624 51.207032-11.871093 69.015625 5.933594 17.832031 17.835938 15.304688 45.902344 5.917969 69l34.964844 34.964844c87.195312-52.550781 188.710937-135.34375 231.878906-245.496094-29.859375-4.511718-60.730469-19.78125-86.097656-45.148437zm-21.21875 127.277343c-29.238282 29.238282-76.820313 29.238282-106.0625 0-29.242188-29.242187-29.242188-76.828124 0-106.066406 29.242187-29.238281 76.824218-29.238281 106.0625 0 29.242187 29.242188 29.242187 76.824219 0 106.066406zm0 0"
          />
        </svg>
        <span>
          Проекты
        </span>
      </div>
      <v-avatar
        v-if="$store.state.user.currentUser.id > 0"
        @click="$router.push({ name: 'profile', params: { id: $store.state.user.currentUser.id } })"
        size="40"
        style="margin-bottom: 11px"
      >
        <v-img :lazy-src="$store.state.user.currentUser.avatar_16" :src="$store.state.user.currentUser.avatar" />
      </v-avatar>

      <div v-else :class="{ active: $route.name === 'login' }" @click="$router.push({ name: 'login' })" class="icon__mobile">
        <svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
          <g>
            <path
              d="m20.1633 4.09295-5.1021-1.92223c-.9183-.30351-1.8367-.20234-2.551.30351-.3061.20234-.5102.40468-.7143.60702h-3.87753c-1.53061 0-2.85715 1.31521-2.85715 2.83276v1.01169c0 .40468.30613.80936.81633.80936.51021 0 .81633-.40468.81633-.80936v-1.01169c0-.70819.61224-1.21404 1.22449-1.21404h3.36733v14.66963h-3.36733c-.71429 0-1.22449-.607-1.22449-1.2141v-1.0116c0-.4047-.30612-.8094-.81633-.8094-.5102 0-.81633.3035-.81633.7082v1.0117c0 1.5175 1.2245 2.8327 2.85715 2.8327h3.87753c.2041.2024.4082.5059.6123.6071.5102.3035 1.0204.5058 1.6326.5058.3061 0 .7143-.1012 1.0204-.2023l5.1021-1.9223c1.1224-.4046 1.8367-1.4163 1.8367-2.6304v-10.62281c0-1.11286-.8163-2.22573-1.8367-2.52924z"
            />
            <path
              d="m6.38776 13.5017c-.30613.3035-.30613.8094 0 1.1129.10204.1012.30612.2023.5102.2023s.40816-.1011.5102-.2023l2.04082-2.0234c.10204-.1012.10204-.2023.20408-.2023 0-.1012.10204-.2024.10204-.3035 0-.1012 0-.2024-.10204-.3035 0-.1012-.10204-.2024-.20408-.2024l-2.04082-2.02338c-.30612-.30351-.81632-.30351-1.12245 0-.30612.30351-.30612.80938 0 1.11288l.71429.7082h-4.18367c-.40817 0-.81633.3035-.81633.8093 0 .5059.30612.8094.81633.8094h4.28571z"
            />
          </g>
        </svg>
        <span>
          Вход
        </span>
      </div>
      <div :class="{ active: $route.fullPath.indexOf('messages') !== -1 }" @click="$router.push({ name: 'messages' })" class="icon__mobile">
        <v-badge
          v-if="$store.state.chats.unreadCount > 0"
          :content="$store.state.chats.unreadCount"
          :value="$store.state.chats.unreadCount"
          color="red"
          overlap
        >
          <div :class="{ active: $route.fullPath.indexOf('messages') !== -1 }">
            <svg height="24" viewBox="0 0 60 60" width="24" xmlns="http://www.w3.org/2000/svg">
              <g>
                <path
                  d="M30,1.5c-16.542,0-30,12.112-30,27c0,5.204,1.646,10.245,4.768,14.604c-0.591,6.537-2.175,11.39-4.475,13.689
	c-0.304,0.304-0.38,0.769-0.188,1.153C0.275,58.289,0.625,58.5,1,58.5c0.046,0,0.092-0.003,0.139-0.01
	c0.405-0.057,9.813-1.411,16.618-5.339C21.621,54.71,25.737,55.5,30,55.5c16.542,0,30-12.112,30-27S46.542,1.5,30,1.5z M16,32.5
	c-2.206,0-4-1.794-4-4s1.794-4,4-4s4,1.794,4,4S18.206,32.5,16,32.5z M30,32.5c-2.206,0-4-1.794-4-4s1.794-4,4-4s4,1.794,4,4
	S32.206,32.5,30,32.5z M44,32.5c-2.206,0-4-1.794-4-4s1.794-4,4-4s4,1.794,4,4S46.206,32.5,44,32.5z"
                />
              </g>
            </svg>
          </div>
        </v-badge>
        <svg v-else height="24" viewBox="0 0 60 60" width="24" xmlns="http://www.w3.org/2000/svg">
          <g>
            <path
              d="M30,1.5c-16.542,0-30,12.112-30,27c0,5.204,1.646,10.245,4.768,14.604c-0.591,6.537-2.175,11.39-4.475,13.689
	c-0.304,0.304-0.38,0.769-0.188,1.153C0.275,58.289,0.625,58.5,1,58.5c0.046,0,0.092-0.003,0.139-0.01
	c0.405-0.057,9.813-1.411,16.618-5.339C21.621,54.71,25.737,55.5,30,55.5c16.542,0,30-12.112,30-27S46.542,1.5,30,1.5z M16,32.5
	c-2.206,0-4-1.794-4-4s1.794-4,4-4s4,1.794,4,4S18.206,32.5,16,32.5z M30,32.5c-2.206,0-4-1.794-4-4s1.794-4,4-4s4,1.794,4,4
	S32.206,32.5,30,32.5z M44,32.5c-2.206,0-4-1.794-4-4s1.794-4,4-4s4,1.794,4,4S46.206,32.5,44,32.5z"
            />
          </g>
        </svg>
        <span>
          Сообщения
        </span>
      </div>

      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <div v-on="on" class="icon__mobile">
            <svg height="24" viewBox="0 0 512 512" width="24">
              <g>
                <g>
                  <circle cx="192" cy="42.667" r="42.667" />
                </g>
              </g>
              <g>
                <g>
                  <circle cx="192" cy="192" r="42.667" />
                </g>
              </g>
              <g>
                <g>
                  <circle cx="192" cy="341.333" r="42.667" />
                </g>
              </g>
            </svg>
            <span>
              Другое
            </span>
          </div>
        </template>
        <v-list>
          <v-list-item link to="/cases">
            <v-list-item-icon>
              <v-icon>mdi-briefcase</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Кейсы</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="$store.state.user.currentUser.id > 0" link to="/hosting">
            <v-list-item-icon>
              <v-badge overlap color="primary" content="new">
                <v-icon>mdi-server</v-icon>
              </v-badge>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>Хостинг</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            v-if="
              $store.state.user.currentUser.id > 0 && ($store.getters.checkPermission('can_manage_users') || $store.getters.checkPermission('can_manage_pools'))
            "
            link
            to="/admin/groups"
          >
            <v-list-item-icon>
              <v-icon>mdi-settings</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>Админка</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="$store.state.user.currentUser.id > 0" link to="/events">
            <v-list-item-icon>
              <v-icon>mdi-calendar</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>Мероприятия</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            v-if="$store.state.user.currentUser.id > 0"
            link
            :to="{
              path: $vuetify.breakpoint.smAndDown ? '/messages' : '#',
              query: { chat_user_id: $store.state.university.university.name === 'Новгородский государственный университет' ? 2026 : 370 },
            }"
          >
            <v-list-item-icon>
              <v-icon>mdi-help</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>Помощь</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Navigation',
  computed: {
    university() {
      return this.$store.state.university.university
    },
  },
}
</script>

<style scoped>
* {
  box-sizing: border-box;
}

.nav {
  background: white;
  top: 0;
  width: 100%;
  z-index: 100000;
  display: flex;
  justify-content: space-between;
}

.nav-container {
  display: flex;
  align-items: center;
}

.menu-item {
  font-weight: 500;
  height: 100%;
  font-size: 16px;
  position: relative;
  text-align: center;
  margin: 0 16px;
  padding: 20px 10px;
  display: flex;
}

.bottom-line {
  display: none;
}

.menu-item:hover {
  cursor: pointer;
}

.menu-item:hover:after,
.menu-item.active:after {
  content: '';
  display: block;
  width: 100%;
  bottom: -1px;
  position: absolute;
  height: 5px;
  background: var(--accent-color, #7ac94c);
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  left: 0;
}

.logo {
  flex-shrink: 0;
}

.profile {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  cursor: pointer;
}

.nav__mobile {
  box-shadow: 0px -15px 25px -15px rgba(34, 60, 80, 0.3);
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 15px;
  padding-bottom: 5px;
  background: #ebebef;
  z-index: 0;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  display: flex;
  align-items: center;
}

.icon__mobile {
  display: flex;
  flex-direction: column;
  position: relative;
  align-items: center;
  width: 25%;
  justify-content: center;
}

.icon__mobile > span {
  font-size: 9px;
  margin-top: 4px;
  text-align: center;
  font-weight: 300;
}

.icon__mobile > svg {
  fill: #1f1f1f;
}

.active > svg {
  fill: var(--accent-color, #7ac94c);
}

.icon__mobile.active {
  color: var(--accent-color, #7ac94c);
}
</style>
